import { Component, Input } from '@angular/core';
import { BlogList } from '../../../_models/blogs/blog.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-public-blog-card',
  imports: [CommonModule],
  templateUrl: './public-blog-card.html',
  styleUrl: './public-blog-card.scss',
})
export class PublicBlogCard {
  @Input() blog!: BlogList;

  constructor(
    private router: Router
  ) {}

  setDefaultImage(event: any): void {
    event.target.src = './assets/images/blog-default.png';
  }

  readArticle() {
  if (this.blog.slug) {
    this.router.navigate(['/articles', this.blog.slug]);
    } else {
      this.router.navigate(['/articles', this.blog.id]);
    }
  }
}
